import { render, staticRenderFns } from "./StatusDialogSettings.vue?vue&type=template&id=2f0af078"
import script from "./StatusDialogSettings.vue?vue&type=script&lang=js"
export * from "./StatusDialogSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports